import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["onEvent", "activeAnimationId", "autoplay", "background", "direction", "intermission", "loop", "playMode", "hover", "speed", "renderer", "rendererSettings", "src", "className", "testId", "children", "defaultTheme", "light", "worker", "activeStateId", "lottieRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
import { a, e, d } from './chunk-XVC7DH25.js';
import { PlayerState, PlayerEvents, DotLottieCommonPlayer, DEFAULT_STATE } from '@dotlottie/common';
import c, { useRef, useEffect, useState, useCallback, useLayoutEffect } from 'react';
var Z = typeof window > "u" ? useEffect : useLayoutEffect,
  H = function H(e, o, d) {
    var _useState = useState(function () {
        return new DotLottieCommonPlayer(e, o.current, d);
      }),
      _useState2 = _slicedToArray(_useState, 1),
      a = _useState2[0],
      u = useRef(!1);
    return Z(function () {
      function m() {
        return _m.apply(this, arguments);
      }
      function _m() {
        _m = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = !u.current && o.current;
                if (!_context.t0) {
                  _context.next = 6;
                  break;
                }
                u.current = !0;
                a.setContainer(o.current);
                _context.next = 6;
                return a.load();
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return _m.apply(this, arguments);
      }
      return m(), function () {
        u.current && a.destroy();
      };
    }, [a]), a;
  };
function L(e, o) {
  var d$1 = useCallback(function () {
      return o(e.getState());
    }, [o, e]),
    a = useCallback(function (m) {
      return e.state.subscribe(m);
    }, [e]);
  return d(a, d$1, function () {
    return o(DEFAULT_STATE);
  });
}
var N = {
    animation: {
      position: "relative",
      width: "100%",
      height: "100%"
    },
    animationWithControls: {
      position: "relative"
    }
  },
  fe = c.forwardRef(function (_ref, W) {
    var e$1 = _ref.onEvent,
      o = _ref.activeAnimationId,
      d = _ref.autoplay,
      _ref$background = _ref.background,
      a$1 = _ref$background === void 0 ? "transparent" : _ref$background,
      u = _ref.direction,
      m = _ref.intermission,
      D = _ref.loop,
      P = _ref.playMode,
      f = _ref.hover,
      g = _ref.speed,
      _ref$renderer = _ref.renderer,
      U = _ref$renderer === void 0 ? "svg" : _ref$renderer,
      _ref$rendererSettings = _ref.rendererSettings,
      $ = _ref$rendererSettings === void 0 ? {} : _ref$rendererSettings,
      S = _ref.src,
      _ref$className = _ref.className,
      j = _ref$className === void 0 ? "" : _ref$className,
      p = _ref.testId,
      b = _ref.children,
      y = _ref.defaultTheme,
      _ref$light = _ref.light,
      v = _ref$light === void 0 ? !1 : _ref$light,
      _ref$worker = _ref.worker,
      z = _ref$worker === void 0 ? !1 : _ref$worker,
      C = _ref.activeStateId,
      B = _ref.lottieRef,
      I = _objectWithoutProperties(_ref, _excluded);
    var R = useRef(null),
      i = H(S, R, {
        renderer: U,
        activeAnimationId: o,
        rendererSettings: _objectSpread({
          clearCanvas: !0,
          progressiveLoad: !1,
          hideOnTransparent: !0
        }, $),
        hover: f,
        loop: D,
        direction: u,
        speed: g,
        intermission: m,
        background: a$1,
        playMode: P,
        autoplay: f ? !1 : d,
        testId: p,
        defaultTheme: y,
        light: v,
        worker: z,
        activeStateId: C
      }),
      t = useRef(i);
    t.current = i, c.useImperativeHandle(W, function () {
      return i;
    }, [i]), c.useImperativeHandle(B, function () {
      return i;
    }, [i]);
    var T = L(i, function (n) {
        return n.currentState;
      }),
      k = L(i, function (n) {
        return n.frame;
      }),
      q = L(i, function (n) {
        return n.seeker;
      }),
      G = L(i, function (n) {
        return n.currentAnimationId;
      });
    return a(function () {
      typeof D > "u" ? t.current.revertToManifestValues(["loop"]) : t.current.setLoop(D);
    }, [D]), a(function () {
      [PlayerState.Initial, PlayerState.Loading].includes(T) || (typeof d > "u" ? t.current.revertToManifestValues(["autoplay"]) : t.current.setAutoplay(d));
    }, [d]), a(function () {
      typeof u > "u" ? t.current.revertToManifestValues(["direction"]) : t.current.setDirection(u);
    }, [u]), a(function () {
      typeof g > "u" ? t.current.revertToManifestValues(["speed"]) : t.current.setSpeed(g);
    }, [g]), a(function () {
      typeof P > "u" ? t.current.revertToManifestValues(["playMode"]) : t.current.setMode(P);
    }, [P]), a(function () {
      typeof f > "u" ? t.current.revertToManifestValues(["hover"]) : t.current.setHover(f);
    }, [f]), a(function () {
      typeof a$1 > "u" ? t.current.setBackground("transparent") : t.current.setBackground(a$1);
    }, [a$1]), a(function () {
      typeof m > "u" ? t.current.revertToManifestValues(["intermission"]) : t.current.setIntermission(m);
    }, [m]), a(function () {
      typeof y > "u" || !y ? t.current.revertToManifestValues(["defaultTheme"]) : t.current.setDefaultTheme(y);
    }, [y]), a(function () {
      o && t.current.play(o);
    }, [o]), a(function () {
      return typeof C < "u" && t.current.enterInteractiveMode(C), function () {
        t.current.exitInteractiveMode();
      };
    }, [C]), a(function () {
      typeof S < "u" && t.current.updateSrc(S);
    }, [S]), useEffect(function () {
      var n = function n() {
          e$1 == null || e$1(PlayerEvents.Ready);
        },
        w = function w() {
          e$1 == null || e$1(PlayerEvents.DataReady);
        },
        x = function x() {
          e$1 == null || e$1(PlayerEvents.DataFail);
        },
        V = function V() {
          t.current.currentState !== PlayerState.Playing && (e$1 == null || e$1(PlayerEvents.Complete));
        },
        h = function h() {
          e$1 == null || e$1(PlayerEvents.LoopComplete);
        };
      return t.current.addEventListener("DOMLoaded", n), t.current.addEventListener("data_ready", w), t.current.addEventListener("data_failed", x), t.current.addEventListener("complete", V), t.current.addEventListener("loopComplete", h), function () {
        t.current.removeEventListener("DOMLoaded", n), t.current.removeEventListener("data_ready", w), t.current.removeEventListener("data_failed", x), t.current.removeEventListener("complete", V), t.current.removeEventListener("loopComplete", h);
      };
    }, []), useEffect(function () {
      switch (T) {
        case PlayerState.Stopped:
          e$1 == null || e$1(PlayerEvents.Stop);
          break;
        case PlayerState.Paused:
          e$1 == null || e$1(PlayerEvents.Pause);
          break;
        case PlayerState.Playing:
          e$1 == null || e$1(PlayerEvents.Play);
          break;
        case PlayerState.Frozen:
          e$1 == null || e$1(PlayerEvents.Freeze);
          break;
        case PlayerState.Error:
          e$1 == null || e$1(PlayerEvents.Error);
          break;
      }
    }, [T]), useEffect(function () {
      e$1 == null || e$1(PlayerEvents.Frame, {
        frame: k,
        seeker: q
      });
    }, [k]), c.createElement(e, {
      value: i
    }, c.createElement("div", _objectSpread(_objectSpread({
      className: "dotlottie-container main ".concat(b ? "controls" : "", " ").concat(j),
      lang: "en"
    }, p && {
      "data-testid": p
    }), I), c.createElement("div", _objectSpread({
      ref: R,
      "data-name": "".concat(G),
      role: "figure",
      className: "animation ".concat(b ? "controls" : ""),
      style: b ? N.animationWithControls : N.animation
    }, p && {
      "data-testid": "animation"
    }), T === PlayerState.Error && c.createElement("div", _objectSpread(_objectSpread({}, p && {
      "data-testid": "error"
    }), {}, {
      className: "error"
    }), "\u26A0\uFE0F")), b));
  });
export { fe as a };